module.exports = __webpack_public_path__ + "img/article@2x.35366541.jpg";